import {
    ClaimApi,
    ClaimWorkflowHistoryItem,
    CoreFetch,
} from '../../api';
import { makeAutoObservable, runInAction } from 'mobx';
import { IClaimProgressStoreConfig } from './claim-progress.types';

export class ClaimProgressStore {
    public loading = false;
    public data: ClaimWorkflowHistoryItem[] = [];
    public error?: string = undefined;
    private config?: IClaimProgressStoreConfig;
    private fetchToken = 0;

    constructor(config?: IClaimProgressStoreConfig) {
        this.config = config;
        makeAutoObservable(this);
    }

    public setSupportGrant = (support: boolean | undefined): void => {
        const nextSupportGrant = Boolean(support);
        if (this.config?.supportGrant === nextSupportGrant) {
            return;
        }
        this.config = { ...(this.config || {}), supportGrant: nextSupportGrant };
    };

    public reset = (): void => {
        this.fetchToken += 1;
        this.data = [];
        this.error = undefined;
        this.loading = false;
    };

    public fetch = async (claimId: string): Promise<void> => {
        const currentFetchToken = ++this.fetchToken;

        runInAction(() => {
            this.loading = true;
            this.error = undefined;
        });

        try {
            const api = CoreFetch<ClaimApi>(ClaimApi);
            const isSupport = Boolean(this.config?.supportGrant);
            const history = isSupport
                ? await api.getClaimWorkflowHistory({ id: claimId })
                : await api.getClaimWorkflowHistoryProvider({ id: claimId });

            if (currentFetchToken !== this.fetchToken) {
                return;
            }

            runInAction(() => {
                this.data = history;
            });
        } catch (error) {
            if (currentFetchToken !== this.fetchToken) {
                return;
            }

            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to load claim progress';
            });
        } finally {
            if (currentFetchToken === this.fetchToken) {
                runInAction(() => {
                    this.loading = false;
                });
            }
        }
    };
}
